import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbS3: BowlBlock = withIntegration(options.slug.llmKbS3, [
  {
    name: 'remoteUrl',
    type: 'withText',
    required: true,
  },
  {
    name: 'key',
    type: 'withText',
    required: true,
  },
  {
    name: 'secret',
    type: 'withText',
    required: true,
  },
  {
    name: 'token',
    type: 'withText',
  },
  {
    name: 'recursive',
    type: 'checkbox',
  },
  {
    name: 'extension',
    type: 'text',
    hasMany: true,
  },
]);
